export default __webpack_public_path__ + "static/media/profile1v4.28e44cb7.png";